export const PATH_LOGIN = '/Login';
export const PATH_CHANGE_PASSWORD = '/ChangePassword';
export const PATH_SET_PASSWORD = '/SetPassword/';
export const PATH_RESET_PASSWORD = '/ResetPassword/';
export const PATH_REQUEST_PASSWORD_RESET = '/RequestPasswordReset';

export const PATH_CLIENT_DOSEMETER_MEASUREMENT_LIST = '/Client/Dosemeter/Measurement/List';
export const PATH_CLIENT_MEASUREMENT_REPORT_LIST = '/Client/MeasurementReport/List';
